import React from "react";
import { Tag } from "antd";

const FileTypeBadge = ({ document }) => {
    const type = document?.file?.name?.split(".").pop()?.toLowerCase() ?? document?.file?.type;
    if (!type) {
        return null;
    }
    return <Tag className="file-type-badge">{type.toLowerCase()}</Tag>;
};

export default FileTypeBadge;
